import {Platform} from '../../shared/api/messagecentrals/proxy/platforms/api.models';

class SchemaSettings {
    public treatAsNew: boolean   = false;
    public platforms: Platform[] = [];
}

class ContactMomentSettings extends SchemaSettings
{
    public allDaysRequired: boolean = true;
}

export {
    SchemaSettings,
    ContactMomentSettings
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/components/schema.models.ts